import { createSlice } from "@reduxjs/toolkit";

const VISIBILITY_KEY = "label_visibility_v1";

// Load initial state from localStorage
const getInitialState = () => {
  try {
    const stored = localStorage.getItem(VISIBILITY_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

// Save state to localStorage
const saveToLocalStorage = state => {
  try {
    localStorage.setItem(VISIBILITY_KEY, JSON.stringify(state));
  } catch (error) {
    console.error("Failed to save label visibility to localStorage:", error);
  }
};

export const labelVisibilitySlice = createSlice({
  name: "labelVisibility",
  initialState: getInitialState(),
  reducers: {
    toggleLabelVisibility: (state, action) => {
      const { labelKey, isVisible } = action.payload;
      state[labelKey] = isVisible;
      saveToLocalStorage(state);
    },
    setLabelVisibility: (state, action) => {
      const newState = { ...state, ...action.payload };
      saveToLocalStorage(newState);
      return newState;
    },
    resetLabelVisibility: () => {
      const newState = {};
      saveToLocalStorage(newState);
      return newState;
    },
  },
});

export const { toggleLabelVisibility, setLabelVisibility, resetLabelVisibility } = labelVisibilitySlice.actions;

export default labelVisibilitySlice.reducer;
